import router from "./index";
import store from '@/store'
import auth from '@/network/auth'
import { ElMessage } from "element-plus";

router.beforeEach(async (to, from, next) => {

  localStorage.setItem('fullPath', to.fullPath)

  const fullPath = encodeURIComponent(process.env.VUE_APP_DOMAIN + to.fullPath)

  console.log("beforeEach", from, to, fullPath)

  // 刷新前的路由信息
  const routeData = JSON.parse(localStorage.getItem("routeData"))

  console.log("routeData", routeData)

  if (routeData !== null && to.name === routeData.name && Object.keys(to.params).length === 0 && Object.keys(routeData.params).length > 0) {
    next({
      name: routeData.name,
      query: routeData.query,
      params: routeData.params
    });
    store.commit("setRouteData", routeData)
  }
  else {
    store.commit("setRouteData", to)


    if (to.name === 'login') {
      store.commit("setIsAuth", false)
      next()
    } else {

      const auth_message = await checkValidToken().then(res => res)
      const isAuth = auth_message === "OK"

      if (!isAuth) {
        store.commit("setIsAuth", false)
        if (to.name === 'login') {
          next()
        } else {
          if (auth_message === "Update") {
            ElMessage({
              message: "Your session has expired or system updated, please login again.",
              type: "error"
            })
          }
          //判断连接是否有跳转地址
          if (to.fullPath == "/") {
            next('login')
          } else {
            next('login?backurl=' + fullPath)
          }
        }
      } else {
        store.commit("setIsAuth", true)
        // 用户角色
        //await setUserSalesAdmin()
        next()
      }
    }

  }
  localStorage.removeItem("routeData")
})

const checkValidToken = async () => {

  const message = await auth.checkValidToken().then(res => res.data).catch((error) => error)
  return message;
}

